import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule, MatPaginatorIntl } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { MatButtonModule } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DatePipe } from '@angular/common';

// Importation des services
import { IxellAPIService, API_BASE_URL } from './tools/api.service';
import { HeaderService } from './tools/header.service';
import { StorageService } from './tools/storage.service';
import { TchatService } from './tools/api.service';
import { LacourIdPAuthenticationService } from './tools/api.service';

// Importation d'autre chose
import { GlobalColorbookComponent } from './ColorBook/globalColorbook/globalColorbook.component';
import { GlobalMixitCloudComponent } from './ColorWebTechMixitCloud/globalMixitCloud/globalMixitCloud.component';
import { SearchMixitCloudComponent } from './ColorWebTechMixitCloud/searchMixitCloud/searchMixitCloud.component';
import { VariantsComponent } from './ColorWebTechMixitCloud/variantesMixitCloud/variantes.component';
import { FormuleComponent } from './ColorWebTechMixitCloud/formuleMixitCloud/formule.component';
import { GlobalColorwebtechComponent } from './ColorWebTech/globalColorwebtech/globalColorwebtech.component';
import { SearchComponent } from './ColorWebTech/search/search.component';
import { ReferenceListComponent } from './ColorWebTech/reference-list/reference-list.component';
import { VariantListComponent } from './ColorWebTech/variante-list/variante-list.component';
import { ReferenceDetailsComponent } from './ColorWebTech/reference-details/reference-details.component';
import { MultiTonComponent } from './ColorWebTech/multiTon/multiTon.component';
import { VehicleComponent } from './ColorBook/vehicle/vehicle.component';
import { BodyShadeComponent } from './ColorBook/bodyShade/bodyShade.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { HomeComponent } from './home/home.component';
import { SideMenuComponent } from './sideMenu/sideMenu.component';
import { ConnectionComponent } from './connection/connection.component';
//import { PasswordforgottenComponent } from './localuser/passwordforgotten/passwordforgotten.component';
import { HomeSupportComponent } from './Support/home-support/home-support.component';
import { ActionMaterielComponent } from './Support/action-materiel/action-materiel.component';
import { UserClientFormComponentV2 } from './Support/user-client-formV2/user-client-formV2.component';
import { CatalogueComponent } from './Support/catalogue/catalogue.component';
import { PanierComponent } from './Support/panier/panier.component';
import { MajComponent } from './Support/maj/maj.component';
import { ProductsListComponent } from './admin/products-list/products-list.component';


import { CarouselModule } from 'ngx-owl-carousel-o';
//import { ResetPwdComponent } from './localuser/reset-pwd/reset-pwd.component';
//import { AcceptAccountComponent } from './localuser/accept-account/accept-account.component';
import { ManageColorUserV2 } from './localuser/manageColorUserV2/manageColorUserV2.component';
//import { ManageColorUser } from './localuser/manageColorUser/manageColorUser.component';
import { HistoColorUser } from './localuser/histoColorUser/histoColorUser.component';
import { HttpConfigInterceptor } from './tools/http-config-interceptor';
import { LogInService } from './tools/login-service';
import { ObjectsService } from './tools/objects.service';
import { Billing } from './models/billing.model';
import { Company } from './models/company.model';
import { Scale } from './models/scale.model';
import { User } from './models/user.model';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuardService } from './tools/auth-guard.service';
import { ActivationlistComponent } from './renaultstaff/activationlist/activationlist.component';
import { HiddenReferences } from './renaultstaff/hiddenReferences/hiddenReferences.component';
import { AdminlacourLicenceComponent } from './admin/adminlacourlicence/adminlacourLicence.component';
import { AdminlacourCommandComponent } from './admin/adminlacourcommand/adminlacourCommand.component';
import { CommonModule } from '@angular/common';
import { Maildata } from './models/maildata';
import { Product } from './entities/product';
import { HistoryComponent } from './Support/history/history.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorService } from './tools/error.service';
import { CguComponent } from './cgu/cgu.component';
import { CgsComponent } from './cgs/cgs.component';
import { ColorUser } from './models/coloruser';
import { RentingComponent } from './Support/renting/renting.component';
import { RenaultmailComponent } from './admin/renaultmail/renaultmail.component';
import { ReferentaccountsComponent } from './renaultstaff/referentaccounts/referentaccounts.component';
import { DroitsComponent } from './renaultstaff/droits/droits.component';
import { LocalaccounthistoryComponent } from './admin/localaccounthistory/localaccounthistory.component';
import { ScaleAutoActivationComponent } from './Support/scale-auto-activation/scale-auto-activation.component';
import { AdminlacourRentingComponent } from './admin/adminlacourrenting/adminlacourRenting.component';
import { AdminhomeComponent } from './admin/adminhome/adminhome.component';
import { ImportFileComponent } from './admin/importFile/importFile.component';
import { ContactAssistanceComponent } from './Support/assistance/contact-assistance/contact-assistance.component';
import { BreakdownFileComponent } from './monitoring/breakdownfile/breakdownfile.component';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { RentinglistComponent } from './renaultstaff/rentinglist/rentinglist.component';
import { ColormatchingComponent } from './Contretypage/colormatching/colormatching.component';
import { ResponseColorMatchingComponent } from './Contretypage/response-color-matching/response-color-matching.component';
import { HistoriqueColorMatchingComponent } from './Contretypage/historique-color-matching/historique-color-matching.component';
import { MatPaginatorIntlTranslated } from './tools/paginator/paginator';
import { LoaderComponent } from './loader/loader.component';
import { HomeAssistanceComponent } from './Support/assistance/home-assistance/home-assistance.component';
import { TchatAssistanceComponent } from './Support/assistance/tchat-assistance/tchat-assistance.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { PlanningComponent } from './Support/planning/planning.component';
import { PlanningHistoryComponent } from './Support/planning/planning-history/planning-history.component';
import { PlanningGestionComponent } from './Support/planning/planning-gestion/planning-gestion.component';
import { MonitoringInterneComponent } from './admin/monitoringInterne/monitoringInterne.component';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UpdateComponent } from './tools/update/update.component';
import { UpdateService } from './tools/update/update.service';
import { GoogleAnalyticsModule } from './tools/google-analytics';
import { GoogleAnalyticsRouterModule } from './tools/google-analytics/google-analytics-router.module';
import { AdminlacourColorUserComponent } from './admin/adminlacour-color-user/adminlacour-color-user.component';
import { ScaleHistoryComponent } from './admin/scale-history/scale-history.component';


import { DocumentComponent } from './Documents/document/document.component';
//import { ScaleHistoryComponent } from './Documents/gestion-document/scale-history.component

import { StatisticsComponent } from './statistics/statistics/statistics.component';
import { CloudComponent } from './cloud/cloud/cloud.component';
import { CloudMissingComponent } from './cloud/missing/missing.component';

import { DiagramComponent } from './chart/mg-chart.component';
import { StatsFiltersComponent } from './statistics/filters/filters.component';
import { StatsFilterComponent } from './statistics/filter/filter.component';
import { StatsGridComponent } from './statistics/grid/grid.component';
import { StatsKFModalComponent } from './statistics/kf-modal/kf-modal.component';
import { StatsAGModalComponent } from './statistics/ag-modal/ag-modal.component';
import { StatsTXTModalComponent } from './statistics/txt-modal/txt-modal.component';
import { CloudCreateModalComponent } from './cloud/create-modal/create-modal.component';
import { CloudEditModalComponent } from './cloud/edit-modal/edit-modal.component';
import { CloudDeleteModalComponent } from './cloud/delete-modal/delete-modal.component';
import { CloudTranslateModalComponent } from './cloud/translate-modal/translate-modal.component';
import { CloudCreateCommModalComponent } from './cloud/create-comm-modal/create-comm-modal.component';
import { CloudHistoryComponent } from './cloud/history/history.component';

import { GridItemDirective } from './statistics/gridItem/gridItem.directive';
import { LegendStatsDirective } from './statistics/legend/legend.directive';

import { OrderByPipe } from './tools/pipes/order-by.pipe';

@NgModule({
    declarations: [
        AppComponent,
        NavBarComponent,
        HomeComponent,
        SideMenuComponent,
        ConnectionComponent,
        //PasswordforgottenComponent,
        GlobalColorwebtechComponent,
        SearchMixitCloudComponent,
        VariantsComponent,
        FormuleComponent,
        GlobalColorbookComponent,
        GlobalMixitCloudComponent,
        SearchComponent,
        ReferenceListComponent,
        VariantListComponent,
        ReferenceDetailsComponent,
        MultiTonComponent,
        VehicleComponent,
        BodyShadeComponent,
        HomeSupportComponent,
        ActionMaterielComponent,
        UserClientFormComponentV2,
        CatalogueComponent,
        PanierComponent,
        MajComponent,
        //ResetPwdComponent,
        //AcceptAccountComponent,
        ManageColorUserV2,
        //ManageColorUser,
        HistoColorUser,
        AdminlacourLicenceComponent,
        AdminlacourCommandComponent,
        ScaleAutoActivationComponent,
        ActivationlistComponent,
        HiddenReferences,
        HistoryComponent,
        ProductsListComponent,
        SearchComponent,
        CguComponent,
        CgsComponent,
        RentingComponent,
        RenaultmailComponent,
        ReferentaccountsComponent,
        DroitsComponent,
        LocalaccounthistoryComponent,
        AdminlacourRentingComponent,
        AdminhomeComponent,
        BreakdownFileComponent,
        ContactAssistanceComponent,
        RentinglistComponent,
        ImportFileComponent,
        ColormatchingComponent,
        ResponseColorMatchingComponent,
        HistoriqueColorMatchingComponent,
        LoaderComponent,
        HomeAssistanceComponent,
        TchatAssistanceComponent,
        PlanningComponent,
        PlanningHistoryComponent,
        PlanningGestionComponent,
        MonitoringInterneComponent,
        UpdateComponent,
        AdminlacourColorUserComponent,
        ScaleHistoryComponent,
        DocumentComponent,
        StatisticsComponent,
        DiagramComponent,
        StatsFiltersComponent,
        StatsFilterComponent,
        StatsGridComponent,
        StatsKFModalComponent,
        StatsAGModalComponent,
        StatsTXTModalComponent,
        CloudCreateModalComponent,
        CloudEditModalComponent,
        CloudDeleteModalComponent,
        CloudTranslateModalComponent,
        CloudCreateCommModalComponent,
        CloudHistoryComponent,
        CloudComponent,
        CloudMissingComponent,
        GridItemDirective,
        LegendStatsDirective
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatSortModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatListModule,
        MatSelectModule,
        MatRadioModule,
        MatSliderModule,
        MatDialogModule,
        MatStepperModule,
        MatIconModule,
        MatTooltipModule,
        MatGridListModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatTreeModule,
        MatButtonModule,
        CarouselModule,
        BrowserAnimationsModule,
        MatProgressBarModule,
        MatChipsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        HttpClientModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatMomentDateModule,
        //DragDropModule,
        MatAutocompleteModule,
        MatTabsModule,
        ServiceWorkerModule.register('ngsw-worker-1.js', { enabled: environment.serviceWorker, registrationStrategy: "registerImmediately"  }),
        GoogleAnalyticsModule.forRoot({ trackingCode: environment.gaTrackingCode }),
        GoogleAnalyticsRouterModule,
        DragDropModule,
        OrderByPipe
    ],
    providers: [
        HttpClientModule,
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
        //{ provide: API_BASE_URL, useValue: (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot },
        { provide: API_BASE_URL, useValue: environment.apiRoot },
        { provide: MatPaginatorIntl, deps: [TranslateService], useFactory: (translateService: TranslateService) => new MatPaginatorIntlTranslated(translateService) },
        IxellAPIService,
        HeaderService,
        StorageService,
        TchatService,
        LacourIdPAuthenticationService,
        LogInService,
        ObjectsService,
        Billing,
        Company,
        Scale,
        User,
        Maildata,
        Product,
        ColorUser,
        AuthGuardService,
        DatePipe,
        ErrorService,
        UpdateService
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
